import React from "react";
import { Form, Select } from "antd";
const { Option } = Select;

const Turma = ({ turmaSelecinada, handleChangeSelectTurma, edicaoSelecinado, turmas, getFieldDecorator }) => (
    <Form.Item label="Turma">
        {getFieldDecorator("turma", {
            rules: [{ required: true, message: "Campo obrigatório" }],
            initialValue: turmaSelecinada
        })(
            <Select placeholder="Selecionar" allowClear={true} onChange={handleChangeSelectTurma} disabled={!edicaoSelecinado}>
                {turmas.map(turma => (
                    <Option key={turma.id} value={turma.id}>
                        {turma.nome}
                    </Option>
                ))}
            </Select>
        )}
    </Form.Item>
);

export default Turma;
